export default {
  form: {
    display_name: {
      label: 'Name des Restaurants',
      placeholder: 'Name des Restaurants eingeben',
      help: 'Steht auf deinem Vertrag und deinen Rechnungen',
    },
    store_address: {
      label: 'Adresse des Restaurants',
      placeholder: 'Adresse suchen',
      help: 'Diese Adresse sehen deine Kunden',
    },
    address: {
      label: 'Adresse',
      placeholder: 'Straße + Hausnummer',
    },
    zip_code: {
      label: 'Postleitzahl',
      placeholder: 'PLZ eingeben',
    },
    city: {
      label: 'Stadt',
      placeholder: 'Stadt eingeben',
    },
    state: {
      label: 'Bundesland',
      placeholder: 'Bundesland auswählen',
    },
    country: {
      label: 'Land',
      help: 'Um dein Restaurant in ein anderes Land zu verlegen, wende dich an den Support',
    },
  },
  staff_notice:
    'Mitarbeitende des Restaurants können Name und Adresse nicht bestätigen. Bitte wende dich an deinen Onboarding-Manager, damit er die Angaben prüft.',
  toasts: {
    saved: 'Restaurantdaten gespeichert',
    error: 'Deine Restaurantdaten konnten nicht gespeichert werden',
  },
  buttons: {
    next: 'Weiter',
  },
};
